import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DataTableDataSource } from './data-table-datasource';
//Service
import { ApiService } from '../../core/services/api.service';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs/internal/observable/merge';
import { Component, Input, Output, ViewChild, EventEmitter, OnInit } from '@angular/core';
import { ShipDetailEnum } from '../../enums/ship-detail-enum';
import { ShipStatusEnum } from '../../enums/ship-status-enum';
import { ShipTypeEnum } from '../../enums/ship-type-enum';
import { EvidenceTypeEnum } from 'src/app/enums/evidence-type-enum';
import {MatPaginatorIntl} from '@angular/material';
import { AuthorizationEnum } from 'src/app/enums/authorization-enum';
import { DateUtcToLocalService } from '../../core/services/date-utc-to-local.service';
import { DeliveryAutorizationEnum } from 'src/app/enums/delivery-autorization-enum';



export function getDutchPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  
  paginatorIntl.itemsPerPageLabel = 'Elementos por página';
  paginatorIntl.nextPageLabel = 'Siguiente Página';
  paginatorIntl.previousPageLabel = 'Página anterior';
  paginatorIntl.getRangeLabel = dutchRangeLabel;
  
  return paginatorIntl;
}

const dutchRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { return `0 de ${length}`; }
  
  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} de ${length}`;
}

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.css']
})
export class DataTableComponent<T> implements OnInit  {
  @Input()
  requestPath: string = "";
  @Input()
  dateDefault: boolean= false;
  @Input()
  options: any;
  @Input() extraParams: any;

  @Output()
  onDetailClick = new EventEmitter<T>();

  @Output()
  onEditClick = new EventEmitter<T>();

  @Output()
  onDeleteClick = new EventEmitter<T>();

  @Output()
  onQRClick = new EventEmitter<T>();

  @Input()
  searchInOpen: boolean = true;


  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;

  dataSource: DataTableDataSource<T>;
  totalElements: number = 10;

  // Enums
  shipDetailEnum = ShipDetailEnum;
  shipStatusEnum = ShipStatusEnum;
  evidenceTypeEnum = EvidenceTypeEnum;
  authorizationEnum = AuthorizationEnum;
  deliveryAutorizationEnum = DeliveryAutorizationEnum;

  constructor(private apiService: ApiService, public dateUtcToLocalService: DateUtcToLocalService) {
    
  }

  

  ngOnInit() {
    this.dataSource = new DataTableDataSource<T>(this.apiService, this.requestPath);
    this.dataSource.counter.subscribe(count => {
      this.totalElements = count;
    });

    if(this.searchInOpen) {
      this.dataSource.loadData("", this.sort.direction, this.sort.active, this.paginator.pageIndex, this.paginator.pageSize, this.extraParams);
    }
  }

  ngAfterViewInit() {
    // this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // merge(this.sort.sortChange, this.paginator.page).pipe(
    merge(this.paginator.page).pipe(
      tap(() => {
        if (this.sort.active != 'action')
          this.loadPage(this.extraParams)
      })
    ).subscribe();
  }

  loadPage(extraParams?: any) {
    this.dataSource.loadData("", this.sort.direction, this.sort.active, this.paginator.pageIndex, this.paginator.pageSize, extraParams);
  }

  firstPage(): void {
    this.paginator.firstPage();
  }

  clickDetail(e: any) {
    this.onDetailClick.emit(e);
  }


  clickEdit(e: any) {
    this.onEditClick.emit(e);
  }


  clickDelete(e: any) {
    this.onDeleteClick.emit(e);
  }

  clickQR(e: any){
    this.onQRClick.emit(e);
  }

  transformEnum(row: any, col: string): any {
    if (!col.includes('_')) {
      return row[col];
    }

    let e = col.substring(col.lastIndexOf('_') + 1), t;

    if (e == 'ShipDetailEnum') {
      t = (row[col.substring(0, col.lastIndexOf('_'))] as ShipDetailEnum);
    }
    else if (e == 'ShipStatusEnum') {
      t = (row[col.substring(0, col.lastIndexOf('_'))] as ShipStatusEnum);
    }
    else if(e == 'EvidenceTypeEnum') {
      t += (row[col.substring(0, col.lastIndexOf('_'))] as EvidenceTypeEnum);
    }

    return t;
  }

  transformEnumTranslate(row: any, col: string): any {
    if (!col.includes('_')) {
      return row[col];
    }

    let e = col.substring(col.lastIndexOf('_') + 1), t = 'GENERAL.ENUMS.';
    
    if (e == 'ShipDetailEnum') {
      t += 'SHIP_DETAIL.' + this.shipDetailEnum[(row[col.substring(0, col.lastIndexOf('_'))] as ShipDetailEnum)];
    }
    else if (e == 'ShipStatusEnum') {
      t += 'SHIP_STATUS.' + this.shipStatusEnum[(row[col.substring(0, col.lastIndexOf('_'))] as ShipStatusEnum)];
    }
    else if(e == 'EvidenceTypeEnum') {
      t += 'EVIDENCE_TYPE.' + this.evidenceTypeEnum[(row[col.substring(0, col.lastIndexOf('_'))] as EvidenceTypeEnum)];
    }
    else if(e == 'AuthorizationEnum') {
      t += 'AUTHORIZATION.' + this.authorizationEnum[(row[col.substring(0, col.lastIndexOf('_'))] as AuthorizationEnum)];
    }
    else if(e == 'DeliveryAutorizationEnum') {
      t += 'DELIVERY_AUTORIZATION.' + this.deliveryAutorizationEnum[(row[col.substring(0, col.lastIndexOf('_'))] as DeliveryAutorizationEnum)];
    }
    else {
      return row[col];
    }

    return t;
  }

  transformIcon(row: any, col: string): string {
    if (!col.includes('_')) {
      return '';
    }

    let e = col.substring(col.lastIndexOf('_') + 1), t = '';

    if (e == 'ShipDetailEnum') {
      switch ((row[col.substring(0, col.lastIndexOf('_'))] as ShipDetailEnum)) {
        case ShipDetailEnum.LOADED:
          t = 'local_shipping';
          break;

        case ShipDetailEnum.REJECTED:
          t = 'cancel_presentation';
          break;

        case ShipDetailEnum.WAREHOUSE:
          t = 'location_city';
          break;
      }
    }
    else if (e == 'ShipStatusEnum') {
      switch ((row[col.substring(0, col.lastIndexOf('_'))] as ShipStatusEnum)) {
        case ShipStatusEnum.LOADED:
          t = 'local_shipping';
          break;

        case ShipStatusEnum.IN_TRANSIT:
          t = 'local_shipping';
          break;

        case ShipStatusEnum.ARRIVED:
          t = 'home';
          break;

        case ShipStatusEnum.ABSENT_CLIENT:
          t = 'voice_over_off';
          break;

        case ShipStatusEnum.DELIVERED:
          t = 'how_to_reg';
          break;

        case ShipStatusEnum.RECOLECTED:
          t = 'local_shipping';
          break;

        case ShipStatusEnum.LANDING:
          t = 'directions_boat';
          break;
      }
    }

    return t;
  }

}
